import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../contentful/graphql";
import { init as initRelay } from "../init-relay";
import { SoftwareCompassPricingPage } from "../pages/software/compass/pricing/software-compass-pricing-page";

initRelay(
    SoftwareCompassPricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars("compass", window.location),
    RELAY_API_CONTENTFUL
);
